import {createStore} from 'redux';

const state = {
	nodo_empresa:'',
	nombre_empresa:'',
	data_report:[],
	labels_report:[],
	tipo_reporte:'',
	mostrar:'noMostrar',
	ruta: {}, 
	empresa:'',
	programacionDia: {}
};

const reducer = (state , action ) =>{
	switch(action.type){
		case 'STATE_EMPRESA':
			return {
				...state,
				nodo_empresa:action.nodo_empresa,
				nombre_empresa:action.nombre_empresa			
			};
		break;	
		
		case 'STATE_REPORT':
			return{			
				...state,
				data_report:action.data_report,
				labels_report:action.labels_report,
				tipo_reporte:action.tipo_reporte
			};
		break;

		case 'STATE_MOSTRAR':
			return{			
				...state,
				mostrar:action.mostrar		
			}	
		break;

		case 'SET_RUTA':
			return {
				...state,
				ruta: action.payload
			}
		break;

		case 'SET_PROGRAMACION':
			return {
				...state,
				programacionDia: action.payload
			}
		break;

		case 'SET_EMPRESA':
			return {
				...state,
				empresa: action.payload
			}
		break;
		default:
			return state
		break;
	}
}
export default createStore(reducer, state);


// WEBPACK FOOTER //
// ./src/store.js